import axios from 'axios';  
import { useEffect, useState } from 'react';
 


export const domain = () =>{
    return "https://panel.ponet.pro/";

  // return "http://localhost/presaleadmin/";
}

export const refURL = (wallet) =>{
   return "https://panel.ponet.pro/ref/"+wallet;
}



const useAPIurl = ()=> {
    return domain() + "API/";
}

export const FileUrl = (path='')=> {
    return domain()+"uploads/"+path;
}

export const HeaderData = () => {
    const [data, setData] = useState({})
    const url = useAPIurl() + "header";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }

 export const HowtobuyData = () => {
    const [data, setData] = useState({})
    const url = useAPIurl() + "howtobuy";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }

 export const RoadmapData = () => {
    const [data, setData] = useState({})
    const url = useAPIurl() + "roadmap";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }

 export const TokenomicsChartData = () => {
    const [data, setData] = useState({})
    const url = useAPIurl() + "tokenomics";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }

 export const TeamData = () => {
    const [data, setData] = useState({})
    const url = useAPIurl() + "team";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }

 export const FooterData = () => {
    const [data, setData] = useState({})
    const url = useAPIurl() + "footer";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }


 export const InvestmentBoxData = () => {
    const [data, setData] = useState({})
    const url = useAPIurl() + "ivesmentbox";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }

 export const LogoData = () => {
    const [data, setData] = useState({})
    const url = useAPIurl() + "image";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }

 export const NavlinkData = () => {
    const [data, setData] = useState([])
    const url = useAPIurl() + "navlinks";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }


 export const FaqData = () => {
    const [data, setData] = useState([])
    const url = useAPIurl() + "faq";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }

 export const SectionData = () => {
    const [data, setData] = useState([])
    const url = useAPIurl() + "sectionvisibility";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }

 export const InfoData = () => {
    const [data, setData] = useState([])
    const url = useAPIurl() + "info";
    useEffect(() => {
      async function fetchData() {
        const headerdatas = await axios.get(url);
        setData(headerdatas.data);
      }
      fetchData()
    }, [])
  
    return data
 }

